import { ListItem } from "@atoms/list-item";
import { Typography } from "@atoms/typography";
import React, { FC, PropsWithChildren } from "react";

export const ListItemText: FC<PropsWithChildren> = ({ children }) => {
  return (
    <ListItem>
      <Typography>{children}</Typography>
    </ListItem>
  );
};
